import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import HttpRunner from '../query';
import DetectLanguageQuery from '../detectLanguageQuery';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocV1Translate extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_TRANSLATE)
        })
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Language Translation</h3>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V1_TRANSLATE}
                </code>
                <div className="description">
                    The translate endpoint allows translation of text from one language to another.<br/>
                </div>

                <h4 className="heading-2" id="translatev1_request">Request</h4>
                <div className="description">
                    The translate request is a JSON object that contains the request parameters.<br/>
                </div>

                <h4 className="heading-3" id="translatev1_request_object">Request object</h4>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">text</td>
                        <td className="meaning">Text to be translated.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">targetLanguage</td>
                        <td className="meaning">A 2-digit language code (ISO-639-1).
                        </td>
                        <td className="type">String
                        </td>
                        <td className="constraints">Required    
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">sourceLanguage</td>
                        <td className="meaning">A 2-digit language code (ISO-639-1). If not provided, <Link to="/documentation/doc_v2detectlanguage">detect-language</Link> will be used to determine the language. 
                        </td>
                        <td className="type">String
                        </td>
                        <td className="constraints">Optional    
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">documentId</td>
                        <td className="meaning">Customer supplied id for request tracking.
                        </td>
                        <td className="type">String
                        </td>
                        <td className="constraints">Optional    
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2" id="translatev1_response">Response</h4>
                <div className="description">
                    The translate response object contains the translated text and the detected source language if available.
                </div>

                <h4 className="heading-3" id="translatev1_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">translatedText</td>
                        <td className="meaning">Text translated into the target language.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">detectedSourceLanguage</td>
                        <td className="meaning">The source language of the initial request, detected automatically, if no <i>sourceLanguage</i> was passed in the initial request.
                        </td>
                        <td className="type">String
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">documentId</td>
                        <td className="meaning">Customer supplied id for request tracking. Only available if request contains <i>documentId</i>.
                        </td>
                        <td className="type">String
                        </td>
                        <td className="constraints">Optional    
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Example</h4>
                <div className="example-content host">
                    <pre>
                        POST {urlHandler.API_ENDPOINT_V1_TRANSLATE}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        Content-Type: application/json<br/>
                        <br/>
                    </pre>
                    <pre>{JSON.stringify(examples.EXAMPLE_REQUEST_TRANSLATE, null, 3)}</pre>
                </div>
                <HttpRunner example="translate1" 
                    query="translate"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_TRANSLATE) : null}
                />
            </div>
        );
    }
}

export default DocV1Translate;